import { Box, Button, Dialog } from "@mui/material";
import MyTable from "../../components/table/table";
import { RequestContext } from "../../context/request.context";
import { useContext, useEffect, useState } from "react";
import { MdAdd } from "react-icons/md";
import UserComponent from "../../components/addUser/addUser";
import PageHeader from "../../components/ui/PageHeader";

const Users = () => {
  const { request } = useContext(RequestContext);
  const [refresh, setRefresh] = useState(0);
  useEffect(() => {
    request(`/user/users?size=10000&desc=true`, "GET");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refresh]);

  const [open, setOpen] = useState(false);

  const addUser = async (user) => {
    try {
      await request("/user/register", "POST", user);
      setOpen(false);
      setRefresh(refresh + 1);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Box>
      {/* Ilgari bu sahifa `Container` ichida edi, ya'ni qolgan sahifalardan
          torroq chiqardi va sarlavhasi ham yo'q edi. */}
      <PageHeader
        title="Foydalanuvchilar"
        subtitle="Panelga kira oladigan xodimlar va ularning huquqlari."
        actions={
          <Button
            startIcon={<MdAdd />}
            variant="contained"
            onClick={() => setOpen(true)}
          >
            Qo'shish
          </Button>
        }
      />
      <Box className="messages--body">
        <MyTable
          setRefresh={setRefresh}
          onClose={() => {
            setOpen(false);
          }}
        />
      </Box>
      <Dialog
        open={open}
        onClose={() => {
          setOpen(false);
        }}
        fullWidth
      >
        <UserComponent
          title={"Foydalanuvchi qo'shish"}
          buttonText={"Qo'shish"}
          action={addUser}
        />
      </Dialog>
    </Box>
  );
};

export default Users;
